<script setup lang="ts">
import { onMounted, ref } from 'vue';
const rootEl = ref<HTMLDivElement>();
const isPlasmidVisible = ref(false);
onMounted(() => {
  const decorationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isPlasmidVisible.value = true;
        } else {
          isPlasmidVisible.value = false;
        }
      });
    },
    { threshold: 0.1 }
  );

  if (rootEl.value) {
    decorationObserver.observe(rootEl.value);
  }
});
</script>

<template>
  <div :class="$style.section" ref="rootEl">
    <div :class="$style.main" aria-hidden="true">
      <div
        :class="[$style.bar, $style.bar1, isPlasmidVisible && $style.plasmidAnimated]"
        style="--delay: 0.04s"
      />
      <div
        :class="[$style.bar, $style.bar2, isPlasmidVisible && $style.plasmidAnimated]"
        style="--delay: 0.12s"
      />
      <div
        :class="[$style.bar, $style.bar3, isPlasmidVisible && $style.plasmidAnimated]"
        style="--delay: 0.2s"
      />
      <div
        :class="[$style.bar, $style.bar4, isPlasmidVisible && $style.plasmidAnimated]"
        style="--delay: 0.28s"
      />
      <div
        :class="[$style.bar, $style.bar5, isPlasmidVisible && $style.plasmidAnimated]"
        style="--delay: 0.36s"
      />
      <div
        :class="[$style.bar, $style.bar6, isPlasmidVisible && $style.plasmidAnimated]"
        style="--delay: 0.44s"
      />
    </div>
  </div>
</template>

<style module lang="scss">
.section {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.main {
  position: relative;
  width: 100%;
  height: 100%;
}

.bar {
  position: absolute;
  width: 96px;
  border-radius: 999px;
  transform: rotate(30deg) translateY(120px);
  transform-origin: center;
  opacity: 0;
  will-change: transform, opacity;
}

.bar1 {
  left: -20px;
  bottom: -200px;
  height: 430px;
  background: linear-gradient(178deg, #000a46 0.5%, #121e6e 97%);
}

.bar2 {
  left: 172px;
  bottom: -120px;
  height: 560px;
  background: linear-gradient(180deg, #6b9171 30%, #121e6e 97%);
}

.bar3 {
  left: 230px;
  bottom: -180px;
  height: 498px;
  background: #121e6e;
}

.bar4 {
  left: 358px;
  bottom: -180px;
  height: 562px;
  background: linear-gradient(180deg, #6b9171 28%, #121e6e 96%);
}

.bar5 {
  left: 404px;
  bottom: -240px;
  height: 462px;
  background: linear-gradient(343deg, #121e6e 2%, #2962ff 92%);
}

.bar6 {
  left: 280px;
  bottom: -200px;
  height: 340px;
  background: linear-gradient(178deg, #000a46 0.5%, #121e6e 97%);
}

.plasmidAnimated {
  animation: plasmidSlideUp 0.88s cubic-bezier(0.18, 0.8, 0.2, 1) var(--delay) forwards;
}

@keyframes plasmidSlideUp {
  0% {
    opacity: 0;
    transform: rotate(30deg) translateY(120px);
  }
  100% {
    opacity: 1;
    transform: rotate(30deg) translateY(0);
  }
}
</style>
